export default "__VITE_ASSET__xsxDN9uQ__"